import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../styles/new.css";
import LoadingBox from "../../components/LoadingBox";
import MessageBox from "../../components/MessageBox";
import CenterModal from "../../components/modals/CenterModal";
import { listCategories } from "../../redux/slices/categorySlice";
import NewProductTab from "./NewProductTab";
import NewVariantTab from "./NewVariantTab";
import NewSpecTab from "./NewSpecTab";
import { productDetails, productReset } from "../../redux/slices/productSlice";
import { useLocation, useNavigate } from "react-router-dom";

const NewProduct = () => {
  const [tab, setTab] = useState("updateProduct");
  const navigate = useNavigate();
  const location = useLocation();
  const create = useSelector((state) => state?.createProduct);
  const { product } = useSelector((state) => state?.createProduct);
  let slice = location.pathname.length - 5;
  const slug = location.pathname.slice(10, slice);

  const {
    loading: createLoading,
    error: createError,
    updateSuccess,
    createVariantSuccess,
    createSpecSuccess,
    newProduct,
    newVariant,
    newSpec,
  } = create;
  const { activeStore } = useSelector((state) => state?.listStores);

  const dispatch = useDispatch();

  useEffect(() => {
    if (updateSuccess) {
      setTab("updateVariant");
    } else if (createVariantSuccess && newVariant) {
      setTab("updateSpec");
    } else if (createSpecSuccess && newSpec) {
      navigate("/products");
    }

    dispatch(productDetails(slug));
    dispatch(listCategories());
    dispatch(productReset());
  }, [
    dispatch,
    updateSuccess,
    slug,
    createSpecSuccess,
    createVariantSuccess,
    navigate,
    newProduct,
    newSpec,
    newVariant,
  ]);

  return (
    <div className="mt-16 flex flex-col justify-center items-center">
      <div className="w-1/2">
        <p className="text-gray-700">
          <span className="text-xl">Update </span>
          <span className="text-xl font-semibold">
            {activeStore?.brand_name}
          </span>
          <span className="text-xl"> Product </span>
        </p>
        <div className="flex items-center justify-between w-full border-b-2 border-gray-100 my-8">
          <p
            onClick={() => {
              setTab("updateProduct");
            }}
            className={`cursor-pointer ${
              tab === "updateProduct"
                ? "border-b-2 border-b-primary font-semibold text-gray-800"
                : "text-gray-400"
            }`}
          >
            Update Product
          </p>
          <p
            onClick={() => {
              setTab("updateVariant");
            }}
            className={`cursor-pointer ${
              tab === "updateVariant"
                ? "border-b-2 border-b-primary font-semibold text-gray-800"
                : "text-gray-400"
            }`}
          >
            Update Product Variant
          </p>
          <p
            onClick={() => {
              setTab("updateSpec");
            }}
            className={`cursor-pointer ${
              tab === "updateSpec"
                ? "border-b-2 border-b-primary font-semibold text-gray-800"
                : "text-gray-400"
            }`}
          >
            Update Product Spec
          </p>
        </div>
        <div>
          <div>
            {createLoading && (
              <CenterModal className="bg-transparent text-white">
                <LoadingBox />
              </CenterModal>
            )}
            {createError && (
              <MessageBox variant="danger">{createError}</MessageBox>
            )}
            {tab === "updateProduct" ? (
              <NewProductTab product={product} />
            ) : tab === "updateVariant" ? (
              <NewVariantTab product={product} updateVariant={true} />
            ) : (
              <NewSpecTab product={product} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProduct;
